/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import axios from 'axios';
import React from 'react';
import createReactClass from 'create-react-class';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';

import { getCacheItem } from '../helpers/cacheManager';
import fetch from '../helpers/fetch';
import setStatus from '../helpers/setStatus';
import setResolvedData from '../helpers/setResolvedData';
import startGarbageCollection from '../helpers/startGarbageCollection';
import stopGarbageCollection from '../helpers/stopGarbageCollection';
import hasMetDependencies from '../helpers/hasMetDependencies';
import withContainerCache from './withContainerCache';

const WithContainer = (Component, containerProps) => {
  let container = withContainerCache(createReactClass({

    getInitialState() {
      if (containerProps.axiosInterceptor) {
        axios.interceptors.request.use(containerProps.axiosInterceptor);
      }

      return { isReady: false };
    },

    componentDidMount() {
      each(containerProps.cache, (cache, cacheKey) => {
        const connectedCache = getCacheItem(cacheKey);

        if (!connectedCache) return console.warn(`Cache does not exist: "${cacheKey}"`);

        if (!cache.isListener) {
          connectedCache.isReady = hasMetDependencies({ cache: connectedCache, props: this.props });
          connectedCache.isMounted = true;
          stopGarbageCollection({ cache: connectedCache });
        }

        if (!connectedCache.isReady && !cache.isListener) {
          setStatus({ status: 'unresolved', cacheKey });
          return;
        }

        if (!connectedCache.url && !cache.isListener) {
          setStatus({ status: 'idle', cacheKey });
          return;
        }

        // Fetch will auto set the status to either loading or syncing
        if (connectedCache.url && connectedCache && !cache.isListener && connectedCache.method === 'get' && connectedCache.isReady && connectedCache.isStale) {
          fetch({ props: this.props, cacheKey, options: {} });
          return;
        }

        if (connectedCache.isReady && !cache.isListener && connectedCache.getResolvedData) {
          if (this.props[connectedCache.cacheKey].status === 'unresolved') {
            setResolvedData({ data: connectedCache.getResolvedData({ props: this.props }), cacheKey: connectedCache.cacheKey });
            setStatus({ status: 'idle', cacheKey: connectedCache.cacheKey });
          }
        }
      });

      // This gives enough time for the caches to be formed if undefined
      this.setState({ isReady: true });
    },

    componentDidUpdate(prevProps) {
      // Check for any props changes that make a difference
      each(containerProps.cache, (cache, cacheKey) => {
        const connectedCache = getCacheItem(cacheKey);

        if (!connectedCache || cache.isListener) return;

        if (connectedCache.isReady) {
          // Checking params should only happen once the cache is ready
          // other wise we could end up with undefined unresolved props
          if (!isEqual(connectedCache.getParams({ props: prevProps }), connectedCache.getParams({ props: this.props }))) {
            this.onParamsChanged({ connectedCache });
          }
        }

        if (!isEqual(connectedCache.getDependencies({ props: prevProps }), connectedCache.getDependencies({ props: this.props }))) {
          this.onDependenciesChanged({ connectedCache });
        }
      });
    },

    componentWillUnmount() {
      each(containerProps.cache, (cache, cacheKey) => {
        const connectedCache = getCacheItem(cacheKey);

        if (connectedCache && !cache.isListener) {
          connectedCache.isMounted = false;
          connectedCache.isReady = false;
          startGarbageCollection({ cache: connectedCache });
        }
      });
    },

    onParamsChanged({ connectedCache }) {
      if (hasMetDependencies({ cache: connectedCache, props: this.props })) {
        connectedCache.isReady = true;

        if (connectedCache.getResolvedData) {
          setResolvedData({ data: connectedCache.getResolvedData({ props: this.props }), cacheKey: connectedCache.cacheKey });
        }

        if (!connectedCache.url && !containerProps.isListener) {
          setStatus({ status: 'idle', cacheKey: connectedCache.cacheKey });
          return;
        }
        if (connectedCache.method === 'get' && connectedCache.url) {
          // Fetch will auto set the status to either loading or syncing
          fetch({ props: this.props, cacheKey: connectedCache.cacheKey, options: {} });
        } else if (connectedCache.status === 'unresolved') {
          setStatus({ status: 'idle', cacheKey: connectedCache.cacheKey });
        }
      } else {
        if (this.props[connectedCache.cacheKey].status === 'unresolved') {
          return;
        }
        connectedCache.isReady = false;
        setStatus({ status: 'unresolved', cacheKey: connectedCache.cacheKey });
      }
    },

    onDependenciesChanged({ connectedCache }) {
      if (hasMetDependencies({ cache: connectedCache, props: this.props })) {
        if (!connectedCache.isReady) {
          connectedCache.isReady = true;

          if (connectedCache.getResolvedData) {
            setResolvedData({ data: connectedCache.getResolvedData({ props: this.props }), cacheKey: connectedCache.cacheKey });
          }

          if (!connectedCache.url) {
            setStatus({ status: 'idle', cacheKey: connectedCache.cacheKey });
            return;
          }

          if (connectedCache.method === 'get' && connectedCache.url) {
            // Fetch will auto set the status to either loading or syncing
            fetch({ props: this.props, cacheKey: connectedCache.cacheKey, options: {} });
          } else if (this.props[connectedCache.cacheKey].status === 'unresolved') {
            setStatus({ status: 'idle', cacheKey: connectedCache.cacheKey });
          }
        }
      } else {
        if (this.props[connectedCache.cacheKey].status === 'unresolved') {
          return;
        }
        connectedCache.isReady = false;
        setStatus({ status: 'unresolved', cacheKey: connectedCache.cacheKey });
      }
    },

    render() {
      if (!this.state.isReady) return null;

      const WrappedComponent = Component;

      return <WrappedComponent {...this.props} />;
    },
  }), containerProps);

  if (containerProps.hasRouter) {
    container = withRouter(container);
  }

  if (containerProps.hasTranslations) {
    container = withTranslation()(container);
  }

  return container;
};

export default WithContainer;
